module.exports = __webpack_public_path__ + "img/icon-clock.70c8f92c.svg";